import React, { useState } from "react";
import { FormControl, Form, Button } from "react-bootstrap";
import { BasicFetch } from "../../utils/BasicFetch.ts";

export const ResendVerificationEmailForm = ({ userEmail, onSend }: {
  userEmail: string,
  onSend: () => void
}) => {
  const [email, setEmail] = useState(userEmail);

  const resendVerificationEmail = () => {
    const data = new FormData();
    data.append('email', email);

    BasicFetch({
      url: `${(window as any).serverLocation}user/resend_verification_email_request`,
      method: 'POST',
      data,
      contentType: 'multipart/form-data',
      onSuccess: () => {
        onSend();
      },
      onFail: () => alert('An error occurred while sending the verification email, please try again later. If the problem persists, contact support.')
    })
  }

  return (
    <Form>
      <Form.Group>
        <Form.Label>Email</Form.Label>
        <FormControl className="bg-dark text-light" type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
      </Form.Group>
      <Button variant="outline-light" className="mt-3" onClick={resendVerificationEmail}>Resend Verification Email</Button>
    </Form>
  )
}



